import React, { Fragment, useEffect, useRef, useState } from "react";
import Header from "../../Components/Layout/Header";
import styles from "./Shop.module.css";
import Slider, { SliderThumb } from "@mui/material/Slider";
import { styled } from "@mui/material/styles";
import Typography from "@mui/material/Typography";
import Tooltip from "@mui/material/Tooltip";
import Box from "@mui/material/Box";
import {
  Card,
  CardActions,
  CardContent,
  CardMedia,
  Checkbox,
  Container,
  Grid,
  IconButton,
} from "@mui/material";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import FavoriteBorderOutlinedIcon from "@mui/icons-material/FavoriteBorderOutlined";
import ShareOutlinedIcon from "@mui/icons-material/ShareOutlined";
import ShoppingBagOutlinedIcon from "@mui/icons-material/ShoppingBagOutlined";
import ZoomInIcon from "@mui/icons-material/ZoomIn";
import Parse from "../../API/ParseServer";
import { Link, useSearchParams } from "react-router-dom";
import SearchIcon from "@mui/icons-material/Search";
import ArtworkCard from "../../Components/ArtworkCard/ArtworkCard";
import Footer from "../../Components/Layout/Footer";
import { useCart } from "../../Context/CartContext";

const CustomeSelect = styled(Select)(({ theme }) => ({
  color: "black",
  borderColor: "#863a18",
  "& .MuiOutlinedInput-notchedOutline": {
    borderColor: "#863a18 !important",
  },
  "& .MuiSelect-select": {
    padding: "15px",
  },
}));
const CustomeSlider = styled(Slider)(({ theme }) => ({
  color: "#863a18",
  height: 3,
  padding: "13px 0",
  "& .MuiSlider-thumb": {
    height: 27,
    width: 27,
    backgroundColor: "#fff",
    border: "1px solid currentColor",
    boxShadow: "none !important",

    "& .airbnb-bar": {
      height: 9,
      width: 1,
      backgroundColor: "currentColor",
      marginLeft: 1,
      marginRight: 1,
    },
  },
  "& .MuiSlider-track": {
    height: 7,
  },
  "& .MuiSlider-rail": {
    color: "#d8d8d8",
    opacity: 1,
    height: 7,
    ...theme.applyStyles("dark", {
      color: "#bfbfbf",
      opacity: undefined,
    }),
  },
  "& .MuiSlider-mark": {
    width: 3,
    height: 3,
    borderRadius: 10,
  },
}));
const sizes = [
  {
    value: 0,
    label: "S",
  },
  {
    value: 25,
    label: "M",
  },
  {
    value: 50,
    label: "L",
  },
  {
    value: 75,
    label: "XL",
  },
  {
    value: 100,
    label: "XXL",
  },
];

interface AirbnbThumbComponentProps extends React.HTMLAttributes<unknown> {}

function AirbnbThumbComponent(props: AirbnbThumbComponentProps) {
  const { children, ...other } = props;
  return (
    <SliderThumb {...other}>
      {children}
      <span className="airbnb-bar" />
      <span className="airbnb-bar" />
      <span className="airbnb-bar" />
    </SliderThumb>
  );
}

const Shop = () => {
  const [size, setSize] = useState<number | number[]>([0, 100]);
  const [height, setHeight] = useState<number | number[]>([0, 300]);
  const [width, setWidth] = useState<number | number[]>([0, 300]);
  const [price, setPrice] = useState<number | number[]>([0, 20000]);

  const changeSizeHandler = (event: Event, newValue: number | number[]) => {
    setSize(newValue);
  };
  const changeHeightHandler = (event: Event, newValue: number | number[]) => {
    setHeight(newValue);
  };
  const changeWidthHandler = (event: Event, newValue: number | number[]) => {
    setWidth(newValue);
  };
  const changePriceHandler = (event: Event, newValue: number | number[]) => {
    setPrice(newValue);
  };
  const [medium, setMedium] = React.useState<string[]>([]);
  const mediumChangeHandler = (event: any) => {
    setMedium(event.target.value as Array<string>);
  };

  const [style, setStyle] = React.useState<string[]>([]);
  const styleChangeHandler = (event: any) => {
    setStyle(event.target.value as Array<string>);
  };

  const [theme, setTheme] = React.useState<string[]>([]);
  const themeChangeHandler = (event: any) => {
    setTheme(event.target.value as Array<string>);
  };

  const [deliveryto, setDeliveryto] = React.useState<string[]>([]);
  const deliverytoChangeHandler = (event: any) => {
    setDeliveryto(event.target.value as Array<string>);
  };

  const [sortBy, setSortBy] = React.useState<string>("Most Likes");
  const sortByChangeHandler = (event: any) => {
    setSortBy(event.target.value);
  };

  const [inStock, setInStock] = useState(false);
  const stockHandler = (event: any) => {
    setInStock(event.target.checked);
  };

  const [artworkChange, setArtworkChange] = useState(false);
  const artworkChangeHandler = () => {
    setArtworkChange((current) => !current);
  };

  const [artworks, setArtworks] = useState<any>([]);
  const [loading, setLoading] = useState(false);
  const [loadingMore, setLoadingMore] = useState(false);
  const [error, setError] = useState(null);
  const [page, setPage] = useState(0);
  const [hasMore, setHasMore] = useState(true);
  const PAGE_SIZE = 16;
  const [searchPhrase, setSearchPhrase] = useState("");
  const [searchParams] = useSearchParams();
  const defaultTheme = searchParams.get("theme");
  const defaultStyle = searchParams.get("style");
  const defaultMedium = searchParams.get("medium");
  useEffect(() => {
    if (defaultTheme) {
      setTheme([defaultTheme]);
    }
    if (defaultStyle) {
      setStyle([defaultStyle]);
    }
    if (defaultMedium) {
      setMedium([defaultMedium]);
    }
  }, [defaultTheme, defaultStyle, defaultMedium]);
  const fetchArtworks = async (reset = false) => {
    // if ((reset && loading) || (!reset && loadingMore)) return;
    if (loading) return;
    if (loadingMore) return;
    reset ? setLoading(true) : setLoadingMore(true);

    const query: any = new Parse.Query("Artwork");
    query.limit(PAGE_SIZE);
    query.skip(reset ? 0 : page * PAGE_SIZE);
    if (sortBy === "Alphabetical") {
      query.ascending("title");
    } else if (sortBy === "Most Likes") {
      query.descending("likeCount");
    } else if (sortBy === "Most Expensive") {
      query.descending("price");
    } else if (sortBy === "Least Expensive") {
      query.ascending("price");
    } else {
      query.descending("createdAt"); // default
    }
    if (defaultStyle && !style.includes(defaultStyle))
      query.containedIn(
        "style",
        defaultStyle.trim().replace(/[^\x20-\x7E]/g, ""),
      );
    if (style.length)
      query.containedIn(
        "style",
        style.map((item) => item.trim().replace(/[^\x20-\x7E]/g, "")),
      );
    if (defaultMedium && !medium.includes(defaultMedium))
      query.containedIn(
        "medium",
        defaultMedium.trim().replace(/[^\x20-\x7E]/g, ""),
      );
    if (medium.length)
      query.containedIn(
        "medium",
        medium.map((item) => item.trim().replace(/[^\x20-\x7E]/g, "")),
      );
    if (defaultTheme && !theme.includes(defaultTheme))
      query.containedIn(
        "theme",
        defaultTheme.trim().replace(/[^\x20-\x7E]/g, ""),
      );
    if (theme.length)
      query.containedIn(
        "theme",
        theme.map((item) => item.trim().replace(/[^\x20-\x7E]/g, "")),
      );
    if (deliveryto.length)
      query.containedIn(
        "deliveryTo",
        deliveryto.map((item) => item.trim().replace(/[^\x20-\x7E]/g, "")),
      );

    query.greaterThanOrEqualTo(
      "height",
      Number(
        height.toLocaleString().slice(0, height.toLocaleString().indexOf(",")),
      ),
    );
    query.lessThanOrEqualTo(
      "height",
      Number(
        height.toLocaleString().slice(height.toLocaleString().indexOf(",") + 1),
      ),
    );
    query.greaterThanOrEqualTo(
      "width",
      Number(
        width.toLocaleString().slice(0, width.toLocaleString().indexOf(",")),
      ),
    );
    query.lessThanOrEqualTo(
      "width",
      Number(
        width.toLocaleString().slice(width.toLocaleString().indexOf(",") + 1),
      ),
    );

    query.greaterThanOrEqualTo(
      "price",
      Number(
        price.toLocaleString().slice(0, price.toLocaleString().indexOf(",")),
      ),
    );

    query.lessThanOrEqualTo(
      "price",
      Number(
        price
          .toLocaleString()
          .slice(price.toLocaleString().indexOf(",") + 1)
          .replace(",", ""),
      ),
    );
    if (size) {
      switch (
        size.toLocaleString().slice(0, size.toLocaleString().indexOf(","))
      ) {
        case "0":
          switch (
            size
              .toLocaleString()
              .slice(size.toLocaleString().indexOf(",") + 1)
              .replace(",", "")
          ) {
            case "0":
              query.containedIn("size", ["s"]);
              break;
            case "25":
              query.containedIn("size", ["s", "m"]);
              break;
            case "50":
              query.containedIn("size", ["s", "m", "l"]);
              break;
            case "75":
              query.containedIn("size", ["s", "m", "l", "xl"]);
              break;
            default:
              query.containedIn("size", ["s", "m", "l", "xl", "xxl"]);
              break;
          }
          break;
        case "25":
          switch (
            size
              .toLocaleString()
              .slice(size.toLocaleString().indexOf(",") + 1)
              .replace(",", "")
          ) {
            case "25":
              query.containedIn("size", ["m"]);
              break;
            case "50":
              query.containedIn("size", ["m", "l"]);
              break;
            case "75":
              query.containedIn("size", ["m", "l", "xl"]);
              break;
            default:
              query.containedIn("size", ["m", "l", "xl", "xxl"]);
              break;
          }
          break;
        case "50":
          switch (
            size
              .toLocaleString()
              .slice(size.toLocaleString().indexOf(",") + 1)
              .replace(",", "")
          ) {
            case "50":
              query.containedIn("size", ["l"]);
              break;
            case "75":
              query.containedIn("size", ["l", "xl"]);
              break;
            default:
              query.containedIn("size", ["l", "xl", "xxl"]);
              break;
          }
          break;
        case "75":
          switch (
            size
              .toLocaleString()
              .slice(size.toLocaleString().indexOf(",") + 1)
              .replace(",", "")
          ) {
            case "75":
              query.containedIn("size", ["xl"]);
              break;
            default:
              query.containedIn("size", ["xl", "xxl"]);
              break;
          }
          break;
        case "100":
          query.containedIn("size", ["xl", "xxl"]);
          break;
        default:
          break;
      }
    }
    if (inStock) {
      query.greaterThanOrEqualTo("quantity", 1);
    }
    if (searchPhrase && searchPhrase.length > 0) {
      const orConditions = [
        { artist: { $regex: searchPhrase, $options: "i" } },
        { description: { $regex: searchPhrase, $options: "i" } },
        { title: { $regex: searchPhrase, $options: "i" } },
      ];

      // Merge into existing query._where without overwriting
      query._where = {
        ...query._where,
        $or: orConditions,
      };
    }

    try {
      const results = await query.find();
      if (reset) {
        setArtworks(results);
        setPage(1);
      } else {
        setArtworks((prev: any) => [...prev, ...results]);
        setPage((prev) => prev + 1);
      }

      if (results.length < PAGE_SIZE) {
        setHasMore(false);
      }
      // setArtworks(results);
    } catch (err: any) {
      setError(err.message);
    } finally {
      // reset ? setLoading(false) : setLoadingMore(false);
      setLoading(false);
      setLoadingMore(false);
    }
  };
  useEffect(() => {
    setHasMore(true);
    setPage(0);
    fetchArtworks(true);
  }, [
    medium,
    theme,
    deliveryto,
    height,
    width,
    price,
    size,
    searchPhrase,
    style,
    inStock,
    sortBy,
    defaultMedium,
    defaultStyle,
    defaultTheme,
    // fetchArtworks,
  ]);
  const loadMoreRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    if (!hasMore || loadingMore || loading) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          fetchArtworks(false);
        }
      },
      {
        root: null, // viewport
        rootMargin: "10px",
        threshold: 0,
      },
    );

    const el = loadMoreRef.current;
    if (el) observer.observe(el);

    return () => {
      if (el) observer.unobserve(el);
    };
  }, [hasMore, loadingMore, loading]);

  let timer: number | undefined,
    timeoutVal = 500;

  function handleKeyPress(event: any) {
    window.clearTimeout(timer);
  }

  function handleKeyUp(event: any) {
    window.clearTimeout(timer);
    timer = window.setTimeout(() => {
      setSearchPhrase(event.target.value);
    }, timeoutVal);
  }

  const [basket, setBasket] = useState();
  const [artworkQuantities, setArtworkQuantities] = useState({});
  const { setTotalQuantity } = useCart();
  useEffect(() => {
    const fetchBasket = async () => {
      const user = Parse.User.current();

      if (user || localStorage.getItem("guestId")) {
        try {
          const basket = await Parse.Cloud.run("getBasket", {
            user: user ? user.id : localStorage.getItem("guestId"),
          });
          setBasket(basket);
          const artworkQuantities: any = {};

          basket
            .get("items")
            .filter(
              (item: any) =>
                item.type === "ArtworkFrame" || item.type === "Artwork",
            )
            .forEach((item: any) => {
              const artworkId = item.artwork.id;
              artworkQuantities[artworkId] =
                (artworkQuantities[artworkId] || 0) + item.quantity;
            });
          let totalQuantity = 0;
          basket.get("items").forEach((item: any) => {
            totalQuantity += item.quantity;
          });
          setTotalQuantity(totalQuantity);
          localStorage.setItem("totalQuantity", String(totalQuantity));
          setArtworkQuantities(artworkQuantities);
        } catch (error) {
          console.error("Error fetching basket:", error);
        } finally {
          // setLoading(false);
        }
      }
    };
    fetchBasket();
  }, [artworkChange]);
  const [filters, setFilters] = useState(false);

  return (
    <Fragment>
      <Box sx={{ backgroundColor: "#f3f2f1" }}>
        <Container sx={{ pb: 4, pt: 2 }}>
          <Typography component="h1" variant="h4" sx={{ textAlign: "center" }}>
            Shop
          </Typography>
          <Grid
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              my: 2,
              gap: { xs: 0, sm: 2 },
            }}
            container
          >
            <Grid
              item
              xs={12}
              sm={5.7}
              md={4.5}
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                border: "1px solid #863a18",
                borderRadius: "5px",
                p: "0 10px",
                // margin: "20px 0",
                mb: { xs: 3, sm: 0 },
              }}
            >
              <input
                type="text"
                placeholder="Search Artworks"
                className={styles.input}
                onKeyDown={handleKeyPress}
                onKeyUp={handleKeyUp}
              />
              <SearchIcon sx={{ color: "#863a18" }} />
            </Grid>
            <Grid
              item
              xs={5.7}
              sm={5.7}
              md={1.3}
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <FormControl sx={{ width: "100%" }}>
                <InputLabel
                  id="demo-simple-select-label"
                  sx={{ color: "black !important" }}
                >
                  Sort By
                </InputLabel>
                <CustomeSelect
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={sortBy}
                  label="Sotr By"
                  onChange={sortByChangeHandler}
                  fullWidth
                >
                  <MenuItem value={"Alphabetical"}>Alphabetical</MenuItem>
                  <MenuItem value={"Most Likes"}>Most Likes</MenuItem>
                  <MenuItem value={"Most Expensive"}>Most Expensive</MenuItem>
                  <MenuItem value={"Least Expensive"}>Least Expensive</MenuItem>
                </CustomeSelect>
              </FormControl>
            </Grid>
            <Grid
              item
              xs={5.7}
              sm={5.7}
              md={1.3}
              sx={{
                display: { sx: "flex", sm: "none" },
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <button
                className={styles.button}
                onClick={() => {
                  setFilters((current) => !current);
                }}
              >
                {filters ? "Hide Filters" : "Show Filters"}
              </button>
            </Grid>
          </Grid>
          <Grid
            container
            sx={{
              justifyContent: { xs: "center", sm: "space-between" },
              display: { xs: `${filters ? "block" : "none"}`, sm: "flex" },
              // height: { xs: `${filters ? "auto" : '10px'}`, sm: "auto" },
              transition: "all 300ms",
            }}
          >
            <Grid xs={11.6} sm={5.7} md={2.7}>
              <Typography variant="subtitle1">SIZE</Typography>
              <CustomeSlider
                slots={{ thumb: AirbnbThumbComponent }}
                getAriaLabel={(index) =>
                  index === 0 ? "Minimum size" : "Maximum size"
                }
                defaultValue={[0, 100]}
                marks={sizes}
                step={null}
                onChange={changeSizeHandler}
              />
            </Grid>
            <Grid xs={11.6} sm={5.7} md={2.7}>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <Typography variant="subtitle1">HEIGHT</Typography>
                <Typography>
                  {height.toString().replace(",", " - ")} + cm
                </Typography>
              </Box>
              <CustomeSlider
                slots={{ thumb: AirbnbThumbComponent }}
                getAriaLabel={(index) =>
                  index === 0 ? "Minimum size" : "Maximum size"
                }
                defaultValue={[0, 300]}
                max={300}
                onChange={changeHeightHandler}
              />
            </Grid>
            <Grid xs={11.6} sm={5.7} md={2.7}>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <Typography variant="subtitle1">WIDTH</Typography>
                <Typography>
                  {width.toString().replace(",", " - ")} + cm
                </Typography>
              </Box>
              <CustomeSlider
                slots={{ thumb: AirbnbThumbComponent }}
                getAriaLabel={(index) =>
                  index === 0 ? "Minimum size" : "Maximum size"
                }
                defaultValue={[0, 300]}
                max={300}
                onChange={changeWidthHandler}
              />
            </Grid>
            <Grid xs={11.6} sm={5.7} md={2.7}>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <Typography variant="subtitle1">PRICE</Typography>
                <Typography>
                  {price.toString().replace(",", " - ")} + GBP
                </Typography>
              </Box>
              <CustomeSlider
                slots={{ thumb: AirbnbThumbComponent }}
                getAriaLabel={(index) =>
                  index === 0 ? "Minimum size" : "Maximum size"
                }
                defaultValue={[0, 20000]}
                max={20000}
                onChange={changePriceHandler}
                step={500}
              />
            </Grid>
            <Grid xs={11.6} sm={5.7} md={2.7} sx={{ marginTop: 2 }}>
              <FormControl fullWidth>
                <InputLabel
                  id="demo-simple-select-label"
                  sx={{ color: "black !important" }}
                >
                  MEDIUM
                </InputLabel>
                <CustomeSelect
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={medium}
                  label="Medium"
                  onChange={mediumChangeHandler}
                  fullWidth
                  multiple
                >
                  <MenuItem value={"Acrylic"}>Acrylic</MenuItem>
                  <MenuItem value={"Oil"}>Oil</MenuItem>
                  <MenuItem value={"Mixed Media"}>Mixed Media</MenuItem>
                  <MenuItem value={"Watercolour"}>Watercolour</MenuItem>
                  <MenuItem value={"Gouache"}>Gouache</MenuItem>
                  <MenuItem value={"Ink"}>Ink</MenuItem>
                  <MenuItem value={"Photography"}>Photography</MenuItem>
                  <MenuItem value={"Limited Edition"}>Limited Edition</MenuItem>
                  <MenuItem value={"Pencil Drawing"}>Pencil Drawing</MenuItem>
                  <MenuItem value={"Pastel"}>Pastel</MenuItem>
                  <MenuItem value={"Sculpture"}>Sculpture</MenuItem>
                  <MenuItem value={"Jewellery"}>Jewellery</MenuItem>
                  <MenuItem value={"Book"}>Book</MenuItem>
                </CustomeSelect>
              </FormControl>
            </Grid>
            <Grid xs={11.6} sm={5.7} md={2.7} sx={{ marginTop: 2 }}>
              <FormControl fullWidth>
                <InputLabel
                  id="demo-simple-select-label"
                  sx={{ color: "black !important" }}
                >
                  STYLE
                </InputLabel>
                <CustomeSelect
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={style}
                  label="Style"
                  onChange={styleChangeHandler}
                  fullWidth
                  multiple
                >
                  <MenuItem value={"Abstract"}>Abstract</MenuItem>
                  <MenuItem value={"Cubism"}>Cubism</MenuItem>
                  <MenuItem value={"Expressionism"}>Expressionism</MenuItem>
                  <MenuItem value={"Fauvism"}>Fauvism</MenuItem>
                  <MenuItem value={"Figurative"}>Figurative</MenuItem>
                  <MenuItem value={"Fine Art"}>Fine Art</MenuItem>
                  <MenuItem value={"Futuristics"}>Futuristics</MenuItem>
                  <MenuItem value={"Geometric"}>Geometric</MenuItem>
                  <MenuItem value={"Impressionism"}>Impressionism</MenuItem>
                  <MenuItem value={"Metaphysical"}>Metaphysical</MenuItem>
                  <MenuItem value={"Minimalism"}>Minimalism</MenuItem>
                  <MenuItem value={"Miniature"}>Miniature</MenuItem>
                  <MenuItem value={"Oriental"}>Oriental</MenuItem>
                  <MenuItem value={"Pop Art"}>Pop Art</MenuItem>
                  <MenuItem value={"Realism"}>Realism</MenuItem>
                  <MenuItem value={"Semi-Abstract"}>Semi-Abstract</MenuItem>
                  <MenuItem value={"Surrealism"}>Surrealism</MenuItem>
                  <MenuItem value={"Symbolic"}>Symbolic</MenuItem>
                  <MenuItem value={"Vintage"}>Vintage</MenuItem>
                  <MenuItem value={"Other"}>Other</MenuItem>
                </CustomeSelect>
              </FormControl>
            </Grid>
            <Grid xs={11.6} sm={5.7} md={2.7} sx={{ marginTop: 2 }}>
              <FormControl fullWidth>
                <InputLabel
                  id="demo-simple-select-label"
                  sx={{ color: "black !important" }}
                >
                  THEME
                </InputLabel>
                <CustomeSelect
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={theme}
                  label="Theme"
                  onChange={themeChangeHandler}
                  fullWidth
                  multiple
                >
                  <MenuItem value={"Still Life"}>Still Life</MenuItem>
                  <MenuItem value={"Landscape"}>Landscape</MenuItem>
                  <MenuItem value={"Portraiture"}>Portraiture</MenuItem>
                  <MenuItem value={"Nature"}>Nature</MenuItem>
                  <MenuItem value={"Abstraction"}>Abstraction</MenuItem>
                  <MenuItem value={"Conceptual"}>Conceptual</MenuItem>
                  <MenuItem value={"Pop culture"}>Pop culture</MenuItem>
                  <MenuItem value={"Marine"}>Marine</MenuItem>
                  <MenuItem value={"Provocative"}>Provocative</MenuItem>
                  <MenuItem value={"Religion"}>Religion</MenuItem>
                  <MenuItem value={"Street Art"}>Street Art</MenuItem>
                  <MenuItem value={"Nude"}>Nude</MenuItem>
                  <MenuItem value={"Fantasy"}>Fantasy</MenuItem>
                  <MenuItem value={"Digital"}>Digital</MenuItem>
                  <MenuItem value={"Historical and Political"}>
                    Historical and Political
                  </MenuItem>
                  <MenuItem value={"Animals"}>Animals</MenuItem>
                  <MenuItem value={"Architecture"}>Architecture</MenuItem>
                  <MenuItem value={"Calligraphy"}>Calligraphy</MenuItem>
                  <MenuItem value={"Other"}>Other</MenuItem>
                </CustomeSelect>
              </FormControl>
            </Grid>
            <Grid
              xs={11.6}
              sm={5.7}
              md={2.7}
              sx={{
                marginTop: 2,
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <FormControl sx={{ width: "9.3rem" }}>
                <InputLabel
                  id="demo-simple-select-label"
                  sx={{ color: "black !important" }}
                >
                  DELIVERY TO
                </InputLabel>
                <CustomeSelect
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={deliveryto}
                  label="deliveryto"
                  onChange={deliverytoChangeHandler}
                  fullWidth
                  multiple
                >
                  <MenuItem value={"United Kingdom"}>United Kingdom</MenuItem>
                  <MenuItem value={"USA"}>USA</MenuItem>
                  <MenuItem value={"Europe"}>Europe</MenuItem>
                </CustomeSelect>
              </FormControl>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <Checkbox
                  sx={{
                    color: "#863a18",
                    "&.Mui-checked": {
                      color: "#863a18",
                      fontSize: "30px !important",
                    },
                    "& .MuiSvgIcon-root": { fontSize: 35 },
                    p: 0,
                    mr: 1,
                    fontSize: "30px !important",
                  }}
                  onChange={stockHandler}
                />
                <Typography>In Stock</Typography>
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Box>
      <Box sx={{ backgroundColor: "#f6f6f6a4", width: "100%", pt: 3 }}>
        <Container>
          {loading ? (
            <Box
              sx={{
                width: "100%",
                display: "flex",
                justifyContent: "center",
                pt: 10,
              }}
            >
              <span className={styles.loader}></span>
            </Box>
          ) : artworks && artworks.length > 0 ? (
            <Grid container spacing={5} py={2} alignItems="stretch">
              {artworks.map((artwork: any) => {
                return (
                  <ArtworkCard
                    artwork={artwork}
                    basket={basket}
                    artworkChangeHandler={artworkChangeHandler}
                    artworkQuantities={artworkQuantities}
                    grid={3}
                    key={artwork.id}
                  />
                );
              })}
            </Grid>
          ) : (
            <Typography sx={{ textAlign: "center", mt: 10 }} variant="h5">
              No Artworks match your selected filters. Please broaden your
              search criteria.
            </Typography>
          )}
        </Container>
      </Box>
      {hasMore && (
        <Box
          sx={{ width: "100%", height: "20rem", backgroundColor: "#f6f6f6a4" }}
        ></Box>
      )}
      <Box
        ref={loadMoreRef}
        sx={{ height: "10rem", backgroundColor: "#f6f6f6a4" }}
        className={loading ? styles.none : ""}
      >
        {loadingMore && (
          <Box
            sx={{
              width: "100%",
              display: "flex",
              justifyContent: "center",
              pb: 20,
            }}
          >
            <span className={styles.loader}></span>
          </Box>
        )}
      </Box>
    </Fragment>
  );
};

export default Shop;
